const OvularNoteCountSymbol = ({
  height = 12,
  width: _width = 14,
  fill,
}: {
  height?: number;
  width?: number;
  fill: string;
}) => {
  return (
    <svg height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.203125 7.69679C0.203125 9.92847 1.98769 11.5705 4.80979 11.5705C8.75243 11.5705 13.4006 8.37051 13.4006 4.53877C13.4006 2.3071 11.616 0.707031 8.75243 0.707031C4.9343 0.707031 0.203125 3.69663 0.203125 7.69679Z"
        fill={fill}
      />
    </svg>
  );
};

export default OvularNoteCountSymbol;
